import useCardFormData from "./useCardFormData";
import { TextInput2 } from "../../components/Inputs";

export default function CardForm() {
    const {submit, cardNumber, expiry, cvv, name, setCardNumber, setCvv, setName, accountId, handleChangeExpiry, zipCode, setZipCode } = useCardFormData()

    if (!accountId) {
        return (
            <div>accountId is not given</div>
        )
    }

    return (
        <div className="p-1">
            <div className="mb-4">
                <TextInput2
                    label="Cardholder name"
                    placeholder="Full name on card"
                    value={name}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
                />
            </div>
            <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Card information</label>
                <div className="flex items-center rounded-md ring-1 ring-gray-200 bg-white py-2 px-3 transition-colors duration-200 hover:ring-gray-300 cursor-text">
                    <input
                        type="text"
                        className="appearance-none border-none bg-transparent w-full text-gray-900 px-1 leading-tight focus:outline-none md:text-sm placeholder:text-sm placeholder:text-gray-400"
                        placeholder="Card number"
                        value={cardNumber}
                        onChange={(e) => setCardNumber(e.target.value)}
                    />
                    <div className="flex shrink-0 ml-2">
                        <img src="/networks_image.jpg" className="h-4" />
                    </div>
                </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
                <div className="">
                    <TextInput2
                        placeholder="MM / YY"
                        value={expiry}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeExpiry(e.target.value)}
                    />
                </div>
                <div className="pl-2">
                    <TextInput2
                        placeholder="CVC"
                        value={cvv}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCvv(e.target.value)}
                    />
                </div>
                <div>
                    <TextInput2
                        placeholder="Zip Code"
                        value={zipCode}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setZipCode(e.target.value)}
                    />
                </div>
            </div>
            {/* <button onClick={submit}>test</button> */}
        </div>
    )
}